import { alertDetailedErrorMessage } from './Errors'

export const exportDataToCsv = (headerKeys: string[], data: any[]) => {
    const columnNames = headerKeys.filter((key) => key !== 'element_id')
    const csvContent = validateAndFormCsvData(columnNames, data)
    const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' })

    return csvBlob
}

function validateAndFormCsvData(keys: string[], data: any[]) {
    const separator = ';'
    const sortedData = [keys]

    data.forEach((dataItem) => {
        const rowValuesSorted = keys.map((key) => {
            const fieldValue = dataItem[key]

            // convert non string fieldValue to string to check if csv content contains semicolon
            if (String(fieldValue).includes(separator)) {
                alertDetailedErrorMessage(
                    'Export failed. Data contains semicolon'
                )
                throw new Error('Data contains semicolon')
            }

            return fieldValue
        })

        sortedData.push(rowValuesSorted)
    })

    const csvContent = sortedData.reduce((acc, cur) => {
        acc += cur.join(separator) + '\n'
        return acc
    }, '')

    return csvContent
}
